import { comEsquemaBearer, isKeycloakSession } from '../../../services/auth/keycloak/keycloak.util';

(function() {
  'use strict';

  function HistoricoPedidosCtrl($scope, $state, $stateParams, $tour, $uibModal, $mdToast, NgTableParams, Historico, Perfil, URLAPICOLETA, localStorageService) {

    var vm = this;

    vm.urlApiColeta = URLAPICOLETA;

    vm.user = JSON.parse(localStorage.getItem('ls.user'));

    vm.userHasSecuriryPickUp = function(userId) {
      Historico.userHasSecuriryPickUp(userId)
        .then(function(status) {
          vm.showReleasePickupButton = status.response;
        });
    };

    Perfil.getBetaFeatures().then(function (data){
      vm.mostrarPrevisaoChegadaColaborador = data['funcionalidades'].find(function (feature){
        return feature['codigo'] == 'previsao-chegada-colaborador';
      })['possuiAcesso']
    });

    vm.$onInit = () => {
      if ($stateParams.tour) {
        startTour();
      }
    };

    vm.userHasSecuriryPickUp(vm.user.id);

    // seta primeira e ultima pagina
    $scope.currentPage = 1;

    // objeto de search
    $scope.searchObject = null;

    // existe retorno da busca
    $scope.dados = null;

    // exibe quando não tem retorno
    $scope.noData = null;

    // constroi a tabela e chama o back end a cada dez orders
    function buildTable() {
      $scope.tableBasic = new NgTableParams({
        page: 1,
        count: 10
      }, {
        counts: [10, 50, 100],
        getData: function(params) {
          // retorna as orders do back end
          return Historico.getListaOs($scope.searchObject, (params.page() - 1) * params.count(), params.page() * params.count())
            .then(function(data) {

              $scope.dados = data;

              $scope.dados.pedidos.map(function(data, key) {
                Historico.checkPickupReceipt(data.id)
                  .then(function(status) {
                    data.hasPickupReceipt = status.response;
                  });
              });

              params.total(data.total);
              if ($scope.searchObject != null && $scope.searchObject.situacaoPedido != null) {
                $scope.noData = true;
              }
              return data.pedidos.slice(0, params.count());
            })
            .catch(function(err) {
              if (err.status === '404') {
                $scope.dados = null;
                $scope.noData = true;
              }
            });
        }
      });
    }

    function showAlert(content) {
      var toast = $mdToast.simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position('top right')
        .hideDelay(5000);

      return $mdToast.show(toast);
    }

    // inicia a construção da tabela
    buildTable();

    // função que retorna valor do obj
    var attributesOfObj = [
      'numeroPedido',
      'dataCriacaoFinal',
      'dataCriacaoInicial',
      'situacaoPedido',
    ];

    function getValueOfObj(obj) {

      for (var i = 0; i < attributesOfObj.length; i++) {
        if (obj.hasOwnProperty(attributesOfObj[i])) {
          if (attributesOfObj[i] == "dataCriacaoFinal") {
            return ' DataFinal ' + obj[attributesOfObj[i]] + ' DataInicio ' + obj[attributesOfObj[i + 1]];
          } else {
            return obj[attributesOfObj[i]];
          }
        }
      }

    }

    // verifica se é maior que X e diferente de 0
    $scope.verify = function(num, limit) {
      if (num > limit && num != 0) {
        return true
      } else {
        return false
      }
    };

    // limpa o campo de busca qnd troca a chave da busca
    $scope.limpaCampo = function() {
      $scope.searchObject = null;
      $scope.dates = {
        dataCriacaoInicial: new Date(),
        dataCriacaoFinal: new Date()
      };
      $scope.noData = null;
    };

    // dispara search de acordo com o filtro
    $scope.search = function() {
      if ($scope.buscarPor === 'dataCriacao') {
        $scope.searchObject = $scope.dates;
      }
      buildTable();
      $scope.currentPage = 1;
    };

    // limpa filtro
    $scope.cleanFilter = function() {
      $scope.searchObject = null;
      $scope.dates = {
        dataCriacaoInicial: new Date(),
        dataCriacaoFinal: new Date()
      };
      $scope.buscarPor = null;
      $scope.noData = null;
      buildTable();
      $scope.currentPage = 1;
    };

    // abre datepicker
    $scope.dates = {
      dataCriacaoInicial: new Date(),
      dataCriacaoFinal: new Date()
    };

    $scope.limit = new Date();

    $scope.dateOptions = {
      showWeeks: false,
      startingDay: 1,
      maxDate: new Date(),
    };

    $scope.finalDateOptions = angular.copy($scope.dateOptions);
    $scope.finalDateOptions.minDate = new Date();

    $scope.open = {
      dataCriacaoInicial: false,
      dataCriacaoFinal: false,
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
      return (mode === 'day' && (new Date().toDateString() == date.toDateString()));
    };

    $scope.timeOptions = {
      readonlyInput: false,
      showMeridian: false
    };

    $scope.dateModeOptions = {
      minMode: 'year',
      maxMode: 'year'
    };

    $scope.openCalendar = function(e, date) {
      $scope.open[date] = true;
    };

    // watch dataCriacaoInicial and dataCriacaoFinal to calculate difference
    $scope.calculateWatch = $scope.$watch(function() {
      return $scope.dates;
    }, function() {
      if ($scope.dates.dataCriacaoInicial && $scope.dates.dataCriacaoFinal) {
        var diff = $scope.dates.dataCriacaoInicial.getTime() - $scope.dates.dataCriacaoFinal.getTime();
        $scope.dayRange = Math.round(Math.abs(diff / (1000 * 60 * 60 * 24)))
      } else {
        $scope.dayRange = 'n/a';
      }
    }, true);

    $scope.$on('$destroy', function() {
      $scope.calculateWatch();
    });

    // sempre que mudar a quantidade de itens exibidos na pagina, reseta a pagina para a 1
    $scope.pageUpdate = function() {
      $scope.currentPage = 1;
    };

    $scope.getComprovanteColeta = function (pedidoId) {
      // jQuery.ajax skips both interceptors, so the scheme goes here. It stays synchronous
      // (window.open needs the click), so it cannot wait for a token renewal.
      var token = localStorageService.get('token');
      jQuery.noConflict().ajax({
        url: vm.urlApiColeta + '/v3/pedido/' + pedidoId + '/comprovante/gerar',
        async: false,
        headers: {
          'Authorization': token && isKeycloakSession() ? comEsquemaBearer(token) : token
        },
        type: 'GET',
        success: function(pdf) {
          if (pdf && pdf.length > 0) {
            window.open( pdf, '_blank' );
          } else {
            showAlert('Oops... Alguma coisa está errada :)');
          }
        },
        error: function (xhr, status, error) {
          showAlert('Oops... Alguma coisa está errada :)');
        }
      });
    }

    function startTour() {
      const stepsConfig = [
        {
          title: 'Histórico de coletas',
          text: 'Confira todo o histórico de suas coletas.',
          attachTarget: () => document.querySelector('app-toolbar .mat-tab-link:nth-child(2)'),
          next: {
            text: 'Ir para Configuração',
            action: (ev, ref) => {
              ref.close('to_next_section');
              $state.go('configuracao-coleta', { tour: true }, { inherit: false });
            }
          },
          previous: {
            text: 'Voltar',
            action: (ev, ref) => {
              ref.close('to_prev_section');
              $state.go('pedido.encomendas', { tour: true }, { inherit: false });
            },
          }
        },
      ];

      const steps = $tour.makeTour(stepsConfig);

      $tour.start(steps).subscribe();
    }
  };


  angular.module('mandaeApp')
    .controller('HistoricoPedidosCtrl', HistoricoPedidosCtrl);
})();
